<template>
  <div class="card section">
    <div class="card-content">
      <p class="title">Your information</p>
      <p class="subtitle" v-if="campaignData.campaign && campaignData.campaign.customerFormTitle">{{campaignData.campaign.customerFormTitle}}</p>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Name</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <input :class="['input',errors.firstName? 'is-danger': '']" type="text" placeholder="First name" v-model='customerInfo.firstName'>
            </p>
            <p class="help is-danger" v-if="errors.firstName">{{errors.firstName.msg}}</p>
          </div>
          <div class="field">
            <p class="control is-expanded">
              <input class="input" type="text" placeholder="Last name" v-model='customerInfo.lastName'>
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Email</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control has-icons-left">
              <input :class="['input',errors.email? 'is-danger': '']" type="text" placeholder="Email address" v-model='customerInfo.email'>
              <span class="icon is-small is-left">
                <font-awesome-icon icon="envelope"/>
              </span>
            </div>
            <p class="help is-danger" v-if="errors.email">{{errors.email.msg}}</p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Phone number</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control has-icons-left">
              <input :class="['input',errors.phoneNumber? 'is-danger': '']" type="tel" placeholder="Your phone number" v-model='customerInfo.phoneNumber' maxlength="10" required>
              <span class="icon is-small is-left">
                <font-awesome-icon icon="phone"/>
              </span>
            </div>
            <p class="help is-danger" v-if="errors.phoneNumber">{{errors.phoneNumber.msg}}</p>
          </div>
        </div>
      </div>
     <!-- <div class="field-body">
        <div class="field is-grouped is-grouped-centered">
          <div class="control">
            <vue-recaptcha
              @verify="onVerify"
              @expired="onExpired"
              :sitekey= "siteKey">
            </vue-recaptcha>
            <p class="help is-danger" v-if="errors[`g-recaptcha-response`]">{{errors[`g-recaptcha-response`].msg}}</p>
          </div>
        </div>
      </div> -->
      <div class="field is-grouped is-grouped-centered pt-5">
        <p class="control">
          <a :class="['button is-success is-medium',isLoading? 'is-loading': '']" @click="submitForm">
            Submit
          </a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha';
import Util from '@/util'

export default {
  name: 'CustomerInfoForm',
  props: ['campaignData'],
  components: {
    VueRecaptcha
  },
  data () {
    return {
      customerInfo: {
        firstName: null,
        lastName: null,
        email: null,
        phoneNumber: null,
      //  'g-recaptcha-response': null
      },
      siteKey: '6Lfxjk0nAAAAAJev8l6Buz5UqQRKMD8PdBSn-3xc',
      isLoading: false,
      errors: {}
    }
  },
  mounted () {
    this.isLoading = false
  },
  methods: {
    submitForm () {
      this.validateForm()
      if (Object.keys(this.errors).length === 0) {
        this.isLoading = true
        this.$emit('submit', this.customerInfo)
      }
    },

    /* onVerify: function (response) {
      this.customerInfo['g-recaptcha-response'] = response
    }, */

    /* onExpired: function () {
      this.customerInfo['g-recaptcha-response'] = null
    }, */

    validateForm () {
      this.errors = {}
      if (!this.customerInfo.firstName) {
        this.errors['firstName'] = {
          msg: 'First name is required.'
        }
      }
      if (this.customerInfo.email && !Util.isEmail(this.customerInfo.email)) {
        this.errors['email'] = {
          msg: 'Enter valid email.'
        }
      }
      if (!this.customerInfo.phoneNumber) {
        this.errors['phoneNumber'] = {
          msg: 'Phone number is required.'
        }
      } else if (!Util.isPhoneNumber(this.customerInfo.phoneNumber)) {
        this.errors['phoneNumber'] = {
          msg: 'Enter valid phone number.'
        }
      }
      /*if (!this.customerInfo['g-recaptcha-response']) {
        this.errors['g-recaptcha-response'] = {
          msg: 'Please verify that you are not a robot.'
        }
      } */
    }
  }
}
</script>
